module.exports = __webpack_public_path__ + "static/media/privacy_statement_en.7ecb9e58.pdf";